import React from "react";

const Experience = () => {
  return (
    <div className="experience">
      <h3>Expérience</h3>
      <div className="exp-1">
        <h4>Développeur Web et Web mobile</h4>
        <h5>2021-2023</h5>
        <p>
          Suite à un licenciement, j'ai décidé de me reconvertir dans le
          développement Web, avec une formation intensive de 5 mois de novembre
          2021 à avril 2022 avec la Wild Code School. Depuis octobre
          2022, je suis Développeur Web et Web mobile officiellement 🙂,
          actuellement en recherche d'une opportunité ou une alternance afin de m'épanouir dans le Web.
        </p>
      </div>
      <div className="exp-2">
        <h4>Monteur audiovisuel</h4>
        <h5>2010-2021</h5>
        <p>
          Après quelques années, j'ai évolué en tant que Monteur audiovisuel, et
          acquérir d'autres compétences.Passant du Beta dig au HDSR et enfin à
          la numérisation des contenus. On utilisera des logiciels tels que
          Finalcut Pro, Motion, Edius, Adobe(Premiere Pro, Photoshop, After
          Effect) pour fournir aux clients leur média dématérialisé.
        </p>
      </div>
      <div className="exp-3">
        <h4>Technicien audiovisuel</h4>
        <h5>1999-2010</h5>
        <p>
          Sans expérience dans l'audiovisuel, j'ai acquis les bases du métier au
          fil des années, c'est-a-dire, la duplication, le montage vidéo, le
          sous-titrage, le doublage, la création de générique, la mise en
          conformité du prêt à diffuser(TF1, Canal+, France TV).
        </p>
      </div>
    </div>
  );
};

export default Experience;
